import { createFileRoute, notFound } from "@tanstack/react-router";

import { TravelDiseaseView } from "@/components/pages/TravelDiseaseView";
import { meta } from "@/content/meta";
import { diseaseProfile, diseaseWhat } from "@/content/travel/disease-profiles";
import { diseaseName } from "@/content/travel/diseases";
import { isLocale } from "@/i18n/locales";
import { seoHead } from "@/lib/site";
import {
  fillTemplate,
  getDisease,
  uniqueDiseaseCountryCount,
} from "@/lib/travel-data";

export const Route = createFileRoute("/$locale/travel/diseases/$slug")({
  loader: ({ params }) => {
    if (!isLocale(params.locale)) throw notFound();
    const disease = getDisease(params.slug);
    if (!disease) throw notFound();
    return { disease };
  },
  head: ({ params, loaderData }) => {
    if (!isLocale(params.locale) || !loaderData) return {};
    const name = diseaseName(loaderData.disease.slug, params.locale);
    const count = String(uniqueDiseaseCountryCount(loaderData.disease));
    const profile = diseaseProfile(loaderData.disease.slug, params.locale);
    const what = profile ? diseaseWhat(profile) : "";
    return seoHead({
      locale: params.locale,
      path: `/travel/diseases/${loaderData.disease.slug}`,
      title: fillTemplate(meta[params.locale].travelDisease.title, { name }),
      description: fillTemplate(meta[params.locale].travelDisease.description, {
        name,
        count,
        what,
      }),
    });
  },
  component: TravelDiseaseRoute,
});

function TravelDiseaseRoute() {
  const { locale } = Route.useParams();
  const { disease } = Route.useLoaderData();
  if (!isLocale(locale)) throw notFound();
  return <TravelDiseaseView locale={locale} disease={disease} />;
}
